export const EMPLOYEE_PUBLISH = 'employee@employee-publish';
export const GET_EMPLOYEE = 'employee@get-employee';
export const DELETE_EMPLOYEE = 'employee@delete-employee';
export const RESIGN_EMPLOYEE = 'employee@resign-employee';
export const GET_EMPLOYEE_FIELD_VALUE = 'employee@get-single-field-employee';
export const GET_BRANCHES = 'employee@get-branches';
export const GET_DEPARTMENTS = 'employee@get-departments';
export const GET_DESIGNATIONS = 'employee@get-designations';
export const GET_EMPLOYEE_CATEGORIES = 'employee@get-employee-categories';
export const GET_GENDERS = 'employee@get-genders';
export const GET_SHIFTS = 'employee@get-shifts';
